import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=89b5f172&scoped=true"
import script from "./InvoicePreview.vue?vue&type=script&lang=ts"
export * from "./InvoicePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b5f172",
  null
  
)

export default component.exports